module.exports = __webpack_public_path__ + "img/logo-print2.97e0d50a.jpg";